/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressResponseDto
 */
export interface AddressResponseDto {
    /**
     * Country
     * @type {string}
     * @memberof AddressResponseDto
     */
    country?: string;
    /**
     * State or province
     * @type {string}
     * @memberof AddressResponseDto
     */
    state?: string;
    /**
     * City
     * @type {string}
     * @memberof AddressResponseDto
     */
    city?: string;
    /**
     * Postal code or ZIP
     * @type {string}
     * @memberof AddressResponseDto
     */
    zip?: string;
    /**
     * Street address line
     * @type {string}
     * @memberof AddressResponseDto
     */
    line?: string;
}

/**
 * Check if a given object implements the AddressResponseDto interface.
 */
export function instanceOfAddressResponseDto(value: object): value is AddressResponseDto {
    return true;
}

export function AddressResponseDtoFromJSON(json: any): AddressResponseDto {
    return AddressResponseDtoFromJSONTyped(json, false);
}

export function AddressResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'line': json['line'] == null ? undefined : json['line'],
    };
}

export function AddressResponseDtoToJSON(json: any): AddressResponseDto {
    return AddressResponseDtoToJSONTyped(json, false);
}

export function AddressResponseDtoToJSONTyped(value?: AddressResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'zip': value['zip'],
        'line': value['line'],
    };
}

